import { asansourReducers } from 'Feature/Asansour/Common/Actions/reducer';
import { atashsooziReducers } from 'Feature/Atashsoozi/Action/reducer';
import { basicInfoReducers } from 'Feature/BasicInfo/Common/Actions/reducer';
import { landingReducers } from 'Feature/Common/Common/Actions/reducer';
import { havadesEnferadiReducers } from 'Feature/Hadeseh/Common/Actions/reducer';
import { khodroShakhsSalesReducers } from 'Feature/Khodro/ShakhsSales/Reducers/shakhsSalesReducers';
import { ILifeInsuState } from 'Feature/LifeInsu/Action/model';
import { lifeInsuReducers } from 'Feature/LifeInsu/Action/reducer';
import { mosaferatiReducers } from 'Feature/Mosaferati/Common/Actions/reducer';
import { orderReducers } from 'Feature/Orders/Common/Actions/reducer';
import { commonReducers } from 'Shared/Common/reducers/commonReducers';

export const listReducer = {
  landing: landingReducers,
  common: commonReducers,
  order: orderReducers,
  khodroShakhsSales: khodroShakhsSalesReducers,
  atashsoozi: atashsooziReducers,
  basicInfo: basicInfoReducers,
  lifeInsu: lifeInsuReducers,
  mosaferati: mosaferatiReducers,
  havadesEnferadi: havadesEnferadiReducers,
  masooliat: asansourReducers,
};

export interface IApplicationState {
  landing: any;
  common: any;
  order: any;
  khodroShakhsSales: any;
  atashsoozi: any;
  basicInfo: any;
  lifeInsu: ILifeInsuState;
  mosaferati: any;
}
